import React from 'react'
import { Box, Typography, Button } from '@mui/material'
import SearchOffIcon from '@mui/icons-material/SearchOff'
import { Link as RouterLink } from 'react-router-dom'
import * as ROUTES from '../routes'

export default function EmptyPropertys() {
    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', py: 8, gap: 1.5 }}>
            <SearchOffIcon sx={{ fontSize: 52, color: 'text.dimGrey' }} />
            <Typography variant='h6' color='text.secondary' textAlign='center'>
                No properties found
            </Typography>
            <Typography variant='body2' color='text.dimGrey' textAlign='center' maxWidth={340}>
                Try adjusting your filters, or contact us to list a property.
            </Typography>
            <Button
                component={RouterLink}
                to={`/${ROUTES.CONTACT}`}
                variant='outlined'
                size='small'
                sx={{ mt: 1 }}
            >
                Contact Us
            </Button>
        </Box>
    )
}
